import Link from 'next/link'
import { FC, HTMLAttributes } from 'react'

import { useLanguage } from '@/hooks/Contexts'
import { Winner } from '@/models/Index'
import { formatWithGBP } from '@/utils/FloatNumber'
import { Format } from '@/utils/Format'
import { noImage } from '@/utils/Images'

import { ImgFallback } from './Image'

export interface WinnerItemProps extends HTMLAttributes<HTMLDivElement> {
  winner: Winner
  disabled?: boolean
  imgCls?: string
  bodyCls?: string
  titleCls?: boolean | string
  dateCls?: boolean | string
  priceCls?: boolean | string
}

export const WinnerItem: FC<WinnerItemProps> = ({ winner, disabled, className, imgCls, bodyCls, titleCls, dateCls, priceCls, children, ...rest }) => {
  const { winners: winnerStr } = useLanguage()
  return (
    <div {...rest} className={`group flex flex-col overflow-clip relative${disabled ? '' : ' cursor-default'} ${className || ''}`}>
      <ImgFallback
        className={`pointer-events-none ${imgCls || ''}`}
        alt={winner.title || winner.image}
        src={winner.image?.startsWith?.('http') ? winner.image : noImage.src}
      />
      {children}
      {titleCls || dateCls || priceCls ? (
        <div className={`${bodyCls || 'contents'}`}>
          {titleCls ? <div className={`font-semibold ${titleCls}`}>{winner.title}</div> : null}
          {dateCls ? <div className={`${dateCls}`}>{Format.dateMonthYearFormat(winner.created_at)}</div> : null}
          {priceCls ? <div className={`${priceCls}`}>{winnerStr.won_for + formatWithGBP(winner.price)}</div> : null}
        </div>
      ) : null}
      {/* use overlay link instead of wrapping div with anchor */}
      {disabled ? null : (
        <Link href={'/competitions/' + winner.short_name} passHref>
          <a className='absolute inset-0 rounded-lg' />
        </Link>
      )}
    </div>
  )
}
